import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=6b516654&"
import script from "./LayoutLogin.vue?vue&type=script&lang=js&"
export * from "./LayoutLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b516654')) {
      api.createRecord('6b516654', component.options)
    } else {
      api.reload('6b516654', component.options)
    }
    module.hot.accept("./LayoutLogin.vue?vue&type=template&id=6b516654&", function () {
      api.rerender('6b516654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/LayoutLogin.vue"
export default component.exports